import React from 'react';

import { BackToData, LocationAndTeamsFilterState, TimeAndAttendanceLocation } from '@vyce/core/src/types';

interface Context {
  backTo: BackToData | null;
  locations: TimeAndAttendanceLocation[];
  setBackTo: Function;
  getLocations: Function;
  mainDashboardFilters: LocationAndTeamsFilterState | undefined;
  updateMainDashboardFilters: (filters: LocationAndTeamsFilterState) => void;
}

export const TimeModuleContext = React.createContext({} as Context);

export const TimeModuleProvider = TimeModuleContext.Provider;
